import { connect } from 'react-redux';
import CommonLogicComponent from './common_logic_component';
import { initialOrder } from '../../../redux/order/order_action';
import { identifyUser } from '../../utils/analytics/analytics';

const mapStateToProps = ({ user }) => ({
  userId: user && user.user && user.user.userId
});

export default connect(
  mapStateToProps,
  {
    initialOrder,
    identifyUser
  }
)(CommonLogicComponent);
